/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconLocationOn from 'DesignSystem/Svgs/TysiaIconLocationOn/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Profiles/Content/Profile/Location"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.name',
})
let constantData = ', '
let personLocationPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.postal_address.city',
})
let constantData1 = ', '
let personLocationPostalAddressStateValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'location.postal_address.state',
})
let aggregateData = fromAggregate.join(personLocationNameValueData, constantData, personLocationPostalAddressCityValueData, constantData1, personLocationPostalAddressStateValueData)
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 size="medium"
 cursor="default"
 type="secondary"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaIconLocationOn
{...childProps}
  viewPath={`${viewPath}/TysiaIconLocationOn`}
 width={12}
 height={12}
/>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="person.location.name"
 data="', '"
 data="person.location.postal_address.city"
 data="', '"
 data="person.location.postal_address.state"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}